import { FC, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { SortDirection } from '@/gql/graphql';

import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import InboxDetailPanel from './InboxDetailPanel';
import InboxListPanel from './InboxListPanel';

const InboxPage: FC = () => {
  const { emailId } = useParams<{ emailId?: string }>();
  const history = useHistory();

  const [inboxInput, setInboxInput] = useState<{
    searchTerm: string;
    sortDirection: SortDirection;
  }>({
    searchTerm: '',
    sortDirection: 'DESC',
  });

  const handleSelectEmail = (id: string | null) => {
    history.push(id ? `/inbox/${id}` : '/inbox');
  };

  return (
    <AuthenticatedPageWrapper className="inbox-page-override">
      <div className="h-full @screen-md:flex">
        <InboxListPanel
          selectedEmailId={emailId ?? null}
          onSelectEmail={handleSelectEmail}
          searchTerm={inboxInput.searchTerm}
          onChangeSearchTerm={(searchTerm) =>
            setInboxInput((prev) => ({ ...prev, searchTerm }))
          }
          sortDirection={inboxInput.sortDirection}
          onChangeSortDirection={(sortDirection) =>
            setInboxInput((prev) => ({ ...prev, sortDirection }))
          }
        />
        <InboxDetailPanel
          emailId={emailId ?? null}
          onArchived={() => handleSelectEmail(null)}
        />
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default InboxPage;
